import SearchBox from "./SearchBox";

export default function Hero({ onSearch }) {
  return (
    <section className='relative flex justify-end items-center min-h-screen bg-findSpecialist bg-no-repeat bg-cover h-full w-full bg-center'>
      <div className='px-6 laptopS:me-10 text-end text-primary3'>
        <h1 className='text-5xl laptopS:text-6xl font-custom-600 mb-4 max-w-[100rem]'>
          نعمل بأعلى معايير الجودة <p>لنحقق آمالكم</p>
        </h1>

        <p className='laptopS:text-2xl mb-8'>
          شبكة متكاملة لتقديم الخدمات التأهيلية والرعاية النهارية
        </p>
      </div>

      <SearchBox onSearch={onSearch} />
    </section>
  );
}
